module.exports = __webpack_public_path__ + "img/bg-6.769dd07c.jpg";